import { Api } from '@/constants';

export const getImageUrl = (asset: string) => {
  return `${Api.EdupassApi}/contents/categorias/${asset}`;
};

export const getEduplayImageUrl = (asset: string) => {
  return `${Api.EdupassApi}/contents/eduplay/${asset}`;
};
